module.exports = __webpack_public_path__ + "img/Support-skill-314.90cbe148.png";